// extracted by mini-css-extract-plugin
export default {"learnMoreLink":"SjettbH sY3mB1c london3-button"};